import { Box, ISelectMiniOption, Label, SelectMini } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router';
import { filterByOptions, sortByOptions, useTemplatesListDispatch } from '../context/UseTemplatesListContext';
import styled from 'styled-components';
import { TFunction } from 'i18next';

const Wrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.designToken.spacing3};
`;

const ControlWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.designToken.spacing2};
`;

const filterOptions = (t: TFunction, channel: string | undefined) =>
  (Object.keys(filterByOptions) as (keyof typeof filterByOptions)[])
    .filter(k => channel !== 'rcs' || (k !== 'displayTypeEmbedded' && k !== 'displayTypePopup'))
    .map<ISelectMiniOption>(k => ({
      label: t(`designs:designGallery.filters.filterOptions.${filterByOptions[k]}`),
      value: filterByOptions[k],
    }));

const sortOptions = (t: TFunction) =>
  Object.keys(sortByOptions).map<ISelectMiniOption>(k => ({
    label: t(`designs:designGallery.filters.sortOptions.${sortByOptions[k]}`),
    value: sortByOptions[k],
  }));

export function TemplateSorting() {
  const { t } = useTranslation('designs');
  const { channel } = useParams<{ channel?: string }>();
  const dispatch = useTemplatesListDispatch();

  const [filterBy, setFilterBy] = useState({
    label: t(`designs:designGallery.filters.filterOptions.${filterByOptions.showAllTemplates}`),
    value: filterByOptions.showAllTemplates,
  });
  const onFilter = useCallback(
    (option: ISelectMiniOption) => {
      setFilterBy(option);
      dispatch({
        type: 'SET_FILTER',
        payload: {
          filter: option.value,
        },
      });
    },
    [dispatch],
  );

  const [sortBy, setSortBy] = useState({
    label: t(`designs:designGallery.filters.sortOptions.${sortByOptions.nameAToZ}`),
    value: sortByOptions.nameAToZ,
  });
  const onSort = useCallback(
    (option: ISelectMiniOption) => {
      setSortBy(option);
      dispatch({
        type: 'SET_SORTING',
        payload: {
          filter: option.value,
        },
      });
    },
    [dispatch],
  );

  return (
    <Box verticalPositioning="center" horizontalPositioning="end">
      <Wrapper>
        <ControlWrapper>
          <Label name={t('designs:designGallery.filters.filterBy')} />
          <SelectMini
            ariaLabel={t('designs:designGallery.filters.filterByAria')}
            data-testid="TemplateFilter"
            options={filterOptions(t, channel)}
            value={filterBy}
            onChange={onFilter}
            menuPlacement="right"
          />
        </ControlWrapper>
        <ControlWrapper>
          <Label name={t('designs:designGallery.filters.sortBy')} />
          <SelectMini
            ariaLabel={t('designs:designGallery.filters.sortByAria')}
            data-testid="TemplateFilter"
            options={sortOptions(t)}
            value={sortBy}
            onChange={onSort}
            menuPlacement="right"
          />
        </ControlWrapper>
      </Wrapper>
    </Box>
  );
}

export default TemplateSorting;
